<!-- <app-header></app-header> -->
  <div class="hamburger-btn d-md-none" (click)="toggleSidebar()">
   <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 16 16"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m2.75 12.25h10.5m-10.5-4h10.5m-10.5-4h10.5"/></svg>
  </div>
<div class="row crm-main-container">
  @if(isSidebarOpen){
   <div  class="overlay d-md-none" (click)="toggleSidebar()"></div>
  }
  <div class="side-nav-banner" [class.open]="isSidebarOpen" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
@if (isSidebarOpen) {
  <button class="close-btn d-md-none" (click)="toggleSidebar()">
    &times;
  </button>
}


    <div class="side-menu">
      <ul>
        <li [ngClass]="{'active': activeMenu === 'Home'}"  (click)="navigateTo('home','/home')"> <svg xmlns="http://www.w3.org/2000/svg" width="1.6rem" height="1.6rem" viewBox="0 0 24 24"><path fill="currentColor" d="M5 20V9.5l7-5.288L19 9.5V20h-5.192v-6.384h-3.616V20z"/></svg><span>Home</span></li>
        <li [ngClass]="{'active': activeMenu === 'dashboard'}"
          (click)="navigateTo('dashboard', '/inventory/dashboard')">
          <svg xmlns="http://www.w3.org/2000/svg" width="1.6em" height="1.6em" viewBox="0 0 24 24">
            <path fill="currentColor"
              d="M2 2h9v7H2zm2 2v3h5V4zm9-2h9v11h-9zm2 2v7h5V4zM2 11h9v11H2zm2 2v7h5v-7zm9 2h9v7h-9zm2 2v3h5v-3z" />
          </svg>
          <span>Dashboard</span>
        </li>
        <li [ngClass]="{'active': activeMenu === 'inventories'}"
          (click)="navigateTo('inventories', '/inventory/inventories')">
          <svg xmlns="http://www.w3.org/2000/svg" width="1.6em" height="1.6em" viewBox="0 0 24 24">
            <path fill="currentColor"
              d="m15.5 17.125l4.95-4.95q.275-.275.7-.275t.7.275t.275.7t-.275.7l-5.65 5.65q-.3.3-.7.3t-.7-.3l-2.85-2.85q-.275-.275-.275-.7t.275-.7t.7-.275t.7.275zM5 21q-.825 0-1.412-.587T3 19V5q0-.825.588-1.412T5 3h4.175q.275-.875 1.075-1.437T12 1q1 0 1.788.563T14.85 3H19q.825 0 1.413.588T21 5v4q0 .425-.288.713T20 10t-.712-.288T19 9V5h-2v2q0 .425-.288.713T16 8H8q-.425 0-.712-.288T7 7V5H5v14h5q.425 0 .713.288T11 20t-.288.713T10 21zm7-16q.425 0 .713-.288T13 4t-.288-.712T12 3t-.712.288T11 4t.288.713T12 5" />
          </svg>
          <span>Inventories</span>
        </li>
        <li [ngClass]="{'active': activeMenu === 'workstation'}"
          (click)="navigateTo('workstation', '/inventory/workstation')">
          <svg xmlns="http://www.w3.org/2000/svg" width="1.6em" height="1.6em" viewBox="0 0 48 48">
            <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"
              d="M25 6H9a3 3 0 0 0-3 3v22a3 3 0 0 0 3 3h30a3 3 0 0 0 3-3v-8M24 34v8m6-30h12m-6-6v12M14 42h20" />
          </svg>
          <span>Workstation</span>
        </li>
        @if (canViewAssetLogs) {
        <li [ngClass]="{'active': activeMenu === 'asset-logs'}"
          (click)="navigateTo('asset-logs', '/inventory/asset-logs')">
          <svg xmlns="http://www.w3.org/2000/svg" width="1.6em" height="1.6em" viewBox="0 0 24 24">
            <path fill="currentColor"
              d="M13 3a9 9 0 0 0-9 9H1l3.89 3.89l.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7s-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.954 8.954 0 0 0 13 21a9 9 0 0 0 0-18m-1 5v5l4.28 2.54l.72-1.21l-3.5-2.08V8z" />
          </svg>
          <span>Activity Logs</span>
        </li>
        }
        <div>
          <li [ngClass]="{'active': !isMenuExpanded && activeMenu === 'request'}">
            <svg xmlns="http://www.w3.org/2000/svg" width="1.6em" height="1.6em" viewBox="0 0 24 24">
              <path fill="currentColor"
                d="M20 8h-3V6c0-1.1-.9-2-2-2H9c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v10h20V10c0-1.1-.9-2-2-2M9 6h6v2H9zm11 12H4v-3h2v1h2v-1h8v1h2v-1h2zm-2-5v-1h-2v1H8v-1H6v1H4v-3h16v3z" />
            </svg>
            <span style="border-bottom: 1px solid #e7e7e7;font-weight: 600;">Request</span>
          </li>
          <div style="margin-left: 20px;">
            <li [ngClass]="{'active': isMenuExpanded && activeMenu === 'service-request'}"
              (click)="navigateTo('service-request', '/inventory/service-request')">
              <span>Service Requests</span>

            </li>
            <li [ngClass]="{'active': isMenuExpanded && activeMenu === 'inventory-request'}"
              (click)="navigateTo('inventory-request', '/inventory/inventory-request')">
              <span>Inventory Requests</span>
            </li>
            <li [ngClass]="{'active': isMenuExpanded && activeMenu === 'newInventory-request'}"
              (click)="navigateTo('newInventory-request', '/inventory/new-inventory-request')">
              <span>New Request</span>
            </li>
            <li [ngClass]="{'active': isMenuExpanded && activeMenu === 'return-request'}"
              (click)="navigateTo('return-request', '/inventory/return-request')">
              <span>Return Request</span>
            </li>
           @if (showAdminRequest) {
            <li [ngClass]="{'active': isMenuExpanded && activeMenu === 'admin-request'}"
              (click)="navigateTo('admin-request', '/inventory/admin-request')">
              <span>HR's Requests</span>
              @if(hasAdminRequests){
              <!-- <p class="notification-dot"></p> -->
              }
            </li>
            
          }
          </div>
        </div>
      </ul>
    </div>
  </div>
  <div class="content-container">
    <router-outlet></router-outlet>
  </div>
</div>